/*
D Sri Madhu Priya
*/
//fetch cabs request, success and failure
export const FETCH_CABS_REQUEST = "FETCH_CABS_REQUEST";
export const FETCH_CABS_SUCCESS = "FETCH_CABS_SUCCESS";
export const FETCH_CABS_FAILURE = "FETCH_CABS_FAILURE";
//insert cab request, success and failure
export const INSERT_CAB_REQUEST = "INSERT_CAB_REQUEST";
export const INSERT_CAB_SUCCESS = "INSERT_CAB_SUCCESS";
export const INSERT_CAB_FAILURE = "INSERT_CAB_FAILURE";
//delete cab request, success and failure
export const DELETE_CAB_REQUEST = "DELETE_CAB_REQUEST";
export const DELETE_CAB_SUCCESS = "DELETE_CAB_SUCCESS";
export const DELETE_CAB_FAILURE = "DELETE_CAB_FAILURE";
//update cab request, success and failure
export const UPDATE_CAB_REQUEST = "UPDATE_CAB_REQUEST";
export const UPDATE_CAB_SUCCESS = "UPDATE_CAB_SUCCESS";
export const UPDATE_CAB_FAILURE = "UPDATE_CAB_FAILURE";
//fetch cab request, success and failure
export const FETCH_CAB_REQUEST = "FETCH_CAB_REQUEST";
export const FETCH_CAB_SUCCESS = "FETCH_CAB_SUCCESS";
export const FETCH_CAB_FAILURE = "FETCH_CAB_FAILURE";
